<template>
    <!-- main -->
    <div class="index-main main">
        <div class="htmldiv">
            <IndexSwiper 
                v-if="info.banner.length > 0"
                :bannerList="info.banner"
                :options="{ 
                    id: 'swiper-banner', 
                    pagination: true, 
                    navigation: true, 
                    showPage: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false
                    },
                    speed: 500,
                    loop: true,
                    paginationClass: 'banner-pagination'
                }" 
                :style="{ height: '360px' }">
            </IndexSwiper>
        </div>
      
        <div class="nsdiv htmldiv ofhidden">
            <div class="news-scroll wd30 ht310 fl">
                <Stitle stitle="推荐新闻" :more="'/news/10'"  :class="'fs16'"/>
                <div class="ht25"></div>
                    <IndexSwiper 
                        v-if="info.recommended_news.length > 0"
                        :bannerList="info.recommended_news"
                        :options="{ 
                            id: 'swiper-index-news', 
                            showPage: true, 
                            loop: true,
                            autoplay: {
                                delay: 5000,
                                disableOnInteraction: false
                            },  
                            effect:  'coverflow'
                        }" 
                        :style="{ height: '300px' }">
                    </IndexSwiper>
            </div>

            <div class="news wd40 ht310 fl pl35 pr35">
                <Stitle stitle="学院新闻" :more="'/news/11'"  :class="'fs16'"/>
                <div class="ht15"></div>
                <News class="news-cur pt5 news-show-date" type='notice' :newsList="info.college_news" :link="'news/detail'" />
            </div>

            <div class="news wd30 ht310 fl">
                <Stitle stitle="通知公告" :more="'/news/12'"  :class="'fs16'"/>
                <div class="ht15"></div>
                <News class="news-cur pt5 news-show-date" type='notice' :newsList="info.notice"  :link="'news/detail'" />
            </div>
        </div>
        <Links />
        <ImgMove v-if="Object.keys(floating_pop).length" :article='floating_pop' />
    </div>
</template>
<script>

import News from '@/components/common/News'
import Stitle from '@/components/common/Stitle'
import Links from '@/components/index/Links'
import IndexSwiper from '@/components/index/IndexSwiper'
import ImgMove from '@/components/common/ImgMove.vue'
export default {
    name: 'Index',
    data() {
        return {
            info: {
                banner: [], 
                college_news: [], //学院新闻
                notice: [],  //通知公告
                recommended_news: [], //推荐新闻
            },
            floating_pop: {}
        }
    },
    components: {
        IndexSwiper,
        News,
        Stitle,
        Links,
        ImgMove
    },
    created() {
        this.$request.get('home', {}, res => {
            if (res.data.code == 200) {
                this.info = res.data.data
                // if(this.info.floating_pop)
                //     this.floating_pop = (this.info.floating_pop)[0]
                if(this.info.floating_pop)
                    this.floating_pop = this.info.floating_pop
            }

        }, error => {
            console.log(error)
        })
    }
}
</script>
<style scope>

</style>
  